const selectMe = state => state.me.item || {};

const selectRequestStatus = state => state.me.status;

export default {
  selectMe,
  selectRequestStatus,
};
